import React from 'react';
import PropTypes from 'prop-types';
import './GuaranteePanel.css';

const GuaranteePanel = ({ children, isHidden }) => {
  return (
    <div
      data-testid='guarantee-panel'
      className={`guarantee-panel${isHidden ? ' guarantee-panel--hidden' : ''}`}
    >
      <div className='guarantee-panel-container'>{children}</div>
    </div>
  );
};

GuaranteePanel.propTypes = {
  children: PropTypes.node.isRequired,
  /** Hides the panel entirely (background, borders, content) while keeping its box, so
      showing and hiding it causes no layout shift. */
  isHidden: PropTypes.bool,
};

GuaranteePanel.defaultProps = {
  isHidden: false,
};

export default GuaranteePanel;
